import React, { ReactElement, useState, useEffect } from 'react';
import { formateDatePile, getLoginInfoPromise } from '../../../../utils/common';
import { useHistory } from 'react-router-dom';
import { getHomechargeOrders } from '../../../../api/filling-pile';
import './index.less';
import FullLoading from '../../../../components/full-loading';
import emptyStatus from '@assets/emptyStatus.png';
const InstalledList = (): ReactElement => {
  const [orderList, setOrderList] = useState<any>();
  const [emptyShow, setEmptyShow] = useState<boolean>(false);
  const router = useHistory();
  const setTitle = () => {
    document.title = '选择服务单';
  };
  //判断家充桩的来源
  const judgeSource = item => {
    if (item.createSource === 0) {
      return `家充桩`;
    }
    if (item.createSource === 1) {
      return `随二手车购买的家桩`;
    }
    if (item.createSource === 2) {
      return `随车购买的家桩`;
    }
    if (item.createSource === 3) {
      return `商城购买的家桩`;
    }
  };
  const showDate = time => {
    const res = formateDatePile(time).split(' ')[0];
    return res;
  };
  const gotoPage = (e, item) => {
    console.log('item',item);
    console.log('orderStatusStr',item.orderStatusStr);
    console.log('orderNo', item.orderNo);
    window.location.href = item.url;

    /* if (item.orderStatus === '00' || item.orderStatus === '01') {
      router.push({
        pathname: '/apply-to-install',
        search: '?orderNo=' + (item.orderNo ? item.orderNo : '')
      });
    } else { 
      router.push({
        pathname: '/pile-installation',
        search: '?orderNo=' + (item.orderNo ? item.orderNo : '')
      });
    } */
  };
  useEffect(() => {
    FullLoading.show({
      text: '加载中'
    })
    setTitle();
    getLoginInfoPromise().then(res => {
      getHomechargeOrders({ uid: res.uid, type: 2 }).then(list => {
        FullLoading.hide()
        console.log(list.data);
        setOrderList(list.data);
        if (list.data.length === 0) {
          setEmptyShow(true);
        }
      })
        .catch(err => {
          console.log('err', err);
          setEmptyShow(true);
        })
    })
      .catch(error => {
        console.log('error', error);
        setEmptyShow(true)
      })
  }, []);
  return (
    <div className="serviceOrder-box">
      <div className="content">
          <div className="title">
            你有{orderList && orderList.length}个安装中的家充桩
          </div>
          {orderList &&
            orderList.map((item, index) => (
              <div className="order-item" key={index}>
                <div className="order-status">
                  <div className="text">{judgeSource(item)}</div>
                  <div className="status">{item.orderStatusStr}</div>
                </div>
                <div className="time">购买时间：{showDate(item.createTime)}</div>
                <div className="orderNo">工单号：{item.orderNo}</div>
                <div className="btn">
                  <button
                    onClick={e => gotoPage(e, item)}
                    className={(item.orderStatus === '00' || item.orderStatus === '01') ? 'pre-btn' : ''}
                  >
                    {(item.orderStatus === '00' || item.orderStatus === '01') ? '预约报装' : '查看详情'}
                  </button>
                </div>
              </div>
            ))}
        </div>
      {emptyShow && (
        <div className="empty">
          <img src={emptyStatus} alt="" />
          <div className="title">暂无内容</div>
        </div>
      )}
    </div>
  );
};
export default InstalledList;
